import api from './api'
import getQueryJson from 'bjxy-common/helper/getQueryJson'
export default {
  methods: {
    reportDupRegister () {
      const dataJson = getQueryJson()
      dataJson.href = location.origin + location.pathname
      const params = {
        isPayloadData: true,
        mobile: this.mobile,
        channel: this.source,
        dataJson: JSON.stringify(dataJson)
      }
      this.postSlient(api.REPORT_REGISTER_ASO, params, {
        slientError: true
      }).then(json => {}).catch(err => {})
    }
  },
  watch: {

    // 因为前置接口不在返回isRegister，所以完成注册后主动上报
    // isRegister: {
    //   immediate: true,
    //   handler: function(val) {
    //     if (val) {
    //       this.reportDupRegister()
    //     }
    //   }
    // }
  }
}
